export const  host ='https://mac-backend.onrender.com/'
// export const  host ='http://localhost:8800/'
